import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {L1Model} from '../../../../models/L1Model';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-sl3-filter',
  templateUrl: './sl3-filter.component.html',
  styleUrls: ['./sl3-filter.component.scss']
})
export class Sl3FilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listFilterL1: any[];

  @Input() l1Data: any;
  @Input() l1Selected: L1Model;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('l1Data' in changes) {
      this.listFilterL1 = this.l1Data ? this.l1Data : [];
      this.optionSelected = null;
    }
    if (this.l1Selected) {
      this.optionSelected = this.l1Selected;
    }
  }

  ngOnDestroy(): void {
  }
}
